module.exports = __webpack_public_path__ + "static/media/Reporting5.a19a36ba.png";